// This is for downloading selected form entries of contact us form
$('#downloadSelected').on('submit', function(e){
    e.preventDefault();

    if($('input:checked').length > 0) {
        // Store the ID's of checked inputs in form entry views inside an array
        var data = $('.formEntryCheckbox:checked').map(function(){
            return $(this).val();
        }).get();

        var formId = $('input[name="formId"]').val();

        let token = document.head.querySelector('meta[name="csrf-token"]').content;
        let _this = this;

        // Create Request
        let xhr = new XMLHttpRequest();

        xhr.open('post', '/admin/warm-lead-download-selected/' + formId);
        xhr.responseType = 'arraybuffer';
        xhr.setRequestHeader("x-csrf-token", token);
        xhr.setRequestHeader("Content-type", 'application/json');

        xhr.onload = function(e) {

            let blob = new Blob([this.response], {type:"application/csv"});
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Warm_Leads.csv';
            link.click();

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, 'Warm_Leads.csv');
                return;
            }

        };
        xhr.send(JSON.stringify({
            formEntryIds: data
        }));
    }

});


// WEBPACK FOOTER //
// ./resources/assets/js/FormBuilder.js